import TableRow from '@mui/material/TableRow';
import { FC } from 'react';

const DataTableBodyRow: FC<PropsWithChildren> = ({ children }) => {
  return <TableRow>{children}</TableRow>;
};

export default DataTableBodyRow;
